// Components
import CustomFAQ from 'components/common/CustomFAQ';

const Faq = ({ faqList }) => {

    return (
        <div>
            <CustomFAQ faq={faqList} />
        </div>
    )
}

export default Faq;